var numSlick = 0;

// Spllit feature slider with background image and content area
var $sliderCarousel = $('.slider-split');
var sliderArrows = '.slider-status .slide-arrows';
var sliderCount = '.slider-status .slide-count';

// Current slide setup
$sliderCarousel.on('init', function(event, slick, currentSlide, nextSlide){
    var i = (currentSlide ? currentSlide : 0) + 1;
    $(sliderCount).text(i + ' of ' + slick.slideCount);
});

// Initialize slider
$sliderCarousel.each( function() {
    $(this).addClass( 'slider-split-' + numSlick ).slick({
        accessibility: false,
        appendDots: $(this).find(sliderCount),
        arrows: false,
        dots: true,
        fade: true,
        infinite: false,
        slide: '.slider-item',
        slidesToScroll: 1,
        slidesToShow: 1,
    })
    .on('init reInit afterChange', function(event, slick, currentSlide, nextSlide){
        var i = (currentSlide ? currentSlide : 0) + 1;
        $(this).closest('.slider').find(sliderCount).text(i + ' of ' + slick.slideCount);

        if (currentSlide == 0) {
            $(this).closest('.slider').find('.slider-arrow.slide-prev').addClass('slick-disabled');
        } else {
            $(this).closest('.slider').find('.slider-arrow.slide-prev').removeClass('slick-disabled');
        }

        if (slick.$slides.length-1 == currentSlide) {
            $(this).closest('.slider').find('.slider-arrow.slide-next').addClass('slick-disabled');
        } else {
            $(this).closest('.slider').find('.slider-arrow.slide-next').removeClass('slick-disabled');
        }
    });

    // Custom prev/next button setup
    $('.slider-arrow.slide-prev').on('click', function() {
        $('.slider-split').slick('slickPrev');
    });
    $('.slider-arrow.slide-next').on('click', function() {
        $('.slider-split').slick('slickNext');
    });

});
